import cx from 'classnames'
import { computed } from 'mobx'

import { ReactComponent as AlignLeftIcon } from 'assets/icons/alignLeft24.svg'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import { useMobileToolbar } from '../stores/MobileToolbarStore'
import { TopTiers } from '../Types'

import Styles from '../MobileToolbar.module.scss'

export const AlignLeftButton = (props: ButtonProps) => {
  const mobileToolbarStore = useMobileToolbar()
  const isSelected = computed(() => mobileToolbarStore.topTier === TopTiers.TextAlign).get()

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: isSelected,
      })}
      {...props}
    >
      <AlignLeftIcon />
    </Button>
  )
}
